import React from 'react'

export const TMTContext = React.createContext({});
export const TMTProvider = TMTContext.Provider

export default TMTContext